module.exports = __webpack_public_path__ + "static/media/TACH.6bbcd9ba.png";